import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from "../../gameData.js";

export default class Popup extends AContainer
{
    constructor(scene, popupType)
    {
        super(scene);

        this.scene = scene;
        this.type = popupType;

        this.btns = [
          gameData.maskLocalization.getLocalizedString("buttonNames.print", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("buttonNames.save", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("buttonNames.yes", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("buttonNames.cancel", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("buttonNames.home", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("buttonNames.mute", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("buttonNames.unmute", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("buttonNames.done", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("buttonNames.english", gameData.maskLocalization.isDefault),
          gameData.maskLocalization.getLocalizedString("buttonNames.new", gameData.maskLocalization.isDefault)
        ];

        this.createShader();
        this.createPopup();
        this.tweenInPopup();

        this.setPosition(this.scene.mid.x, this.scene.mid.y);
        this.scene.addToParent(this, this.scene);
        this.setDepth(100);
        this.setScale(0, 0);
    }

    createShader()
    {
        let rect = new Phaser.Geom.Rectangle(0, 0, this.scene.mid.x*2, this.scene.mid.y*2);
        this.shader = this.scene.add.graphics({ fillStyle: { color: 0xEFE8D8 } });
        this.shader.fillRectShape(rect);
        this.shader.setDepth(90);

        this.shader.alpha = 0;
    }

    createPopup()
    {
        this.btnLocs = [{x:-100, y:-75}, {x:100, y:-75}];
        let yAdj = 0;

        this.bg = this.scene.addImage(0, 0, "Popup_Bckg", this);

        let btnNames;
        let onCompletes;
        let txt;
        if(this.type === "done"){
            btnNames = ["Btn_Print", "Btn_Save"];
            txt = {array:this.btns, ind:0};
            onCompletes = [
                ()=>{this.tweenOutPopup("print");},
                ()=>{this.tweenOutPopup("save");},
                
            ];
        }
        else if(this.type === "reset"){
            btnNames = ["Btn_Yes", "Btn_Cancel"];
            txt = {array:this.btns, ind:2};
            onCompletes = [
                ()=>{this.tweenOutPopup("reset")},
                ()=>{this.tweenOutPopup()}
            ];

            yAdj = 15;

            this.instruct = this.scene.addText(0, -105, 22, "0xf2f0e7", gameData.fonts.din_alternatebold, gameData.maskLocalization.getLocalizedString("miscInfo.confirm", gameData.maskLocalization.isDefault), this, true);
        }
        else if(this.type === "menu"){
            btnNames = ["Btn_Home", "Btn_Unmute", "Btn_Mute"];
            txt = {array:this.btns, ind:4};
            onCompletes = [
                ()=>{this.tweenOutPopup("home")},
                ()=>{this.muteGame()},
                ()=>{this.unmuteGame()}
            ];

            let text3 = txt.array[6];

            this.createThirdBtn(btnNames[2], text3, onCompletes[2]);
        }

        this.exitBtn = this.scene.addButton(this.bg.width/2 - 15, -this.bg.height/2 - 25, "Btn_Close", null, ()=>{
            this.scene.playSound("click");
            this.tweenOutPopup();
        }, this);

        this.btn1 = this.scene.addButton(this.btnLocs[0].x, this.btnLocs[0].y + yAdj, btnNames[0], null, onCompletes[0], this);
        this.btn2 = this.scene.addButton(this.btnLocs[1].x, this.btnLocs[1].y + yAdj, btnNames[1], null, onCompletes[1], this);

        this.name1 = this.scene.addText(this.btn1.x, this.btn1.y + this.btn1.height + 25, 22, "0xf2f0e7", gameData.fonts.din_alternatebold, txt.array[txt.ind], this, true);
        this.name2 = this.scene.addText(this.btn2.x, this.btn2.y + this.btn1.height + 25, 22, "0xf2f0e7", gameData.fonts.din_alternatebold, txt.array[txt.ind+1], this, true);

        this.toggleBtns(false);
        if(this.type === "menu") this.initMuteState();
    }

    createThirdBtn(btnName, btnTxt, onComplete)
    {
        this.btn3 = this.scene.addButton(this.btnLocs[1].x - 1, this.btnLocs[1].y, btnName, null, onComplete, this);
        this.name3 = this.scene.addText(this.btnLocs[1].x, this.btnLocs[1].y + this.btn3.height + 25, 22, "0xf2f0e7", gameData.fonts.din_alternatebold, btnTxt, this, true);
    }

    initMuteState()
    {
        if(gameData.gameMuted){
            this.btn2.visible = false;
            this.btn3.visible = true;
            this.name2.visible = false;
            this.name3.visible = true;
        } else {
            this.btn2.visible = true;
            this.btn3.visible = false;
            this.name2.visible = true;
            this.name3.visible = false;
        }
    }

    muteGame()
    {
        //console.log("muting");
        this.scene.playSound("click");

        gameData.gameMuted = true;

        this.scene.sound.setVolume(0);

        this.btn2.visible = false;
        this.btn3.visible = true;
        this.name2.visible = false;
        this.name3.visible = true;

        this.btn2.setEnabled(false);
        this.btn3.setEnabled(false);
        this.btn3.setEnabled(true);
    }
    
    unmuteGame()
    {
        //console.log("unmuting");
        gameData.gameMuted = false;

        this.scene.sound.setVolume(1);

        this.btn2.visible = true;
        this.btn3.visible = false;
        this.name2.visible = true;
        this.name3.visible = false;

        this.btn2.setEnabled(false);
        this.btn3.setEnabled(false);
        this.btn2.setEnabled(true);
    }

    tweenInPopup()
    {
        gameData.popupOpen = true;
        let newScale = 1;
        this.scene.addTween(this.shader, 300, {alpha:.6}, Phaser.Math.Easing.None);
        this.scene.addTween(this, 500, {scaleX:newScale, scaleY:newScale}, Phaser.Math.Easing.Back.Out,
            ()=>{
                this.toggleBtns(true);
            }
        );
    }

    tweenOutPopup(onEnd = null)
    {
        this.scene.playSound("click");

        this.toggleBtns(false);

        this.scene.addTween(this.shader, 500, {alpha:0}, Phaser.Math.Easing.None);
        this.scene.addTween(this, 500, {scaleX:0, scaleY:0}, Phaser.Math.Easing.Back.In,
            ()=>{
                if(onEnd === "print") this.scene.toggleSavePrint(true, true);
                if(onEnd === "save") this.scene.toggleSavePrint(true, false);
                if(onEnd === "reset") this.scene.resetGame();
                if(onEnd === "home") this.scene.cleanUp("Intro");
                
                if(onEnd !== "print" && onEnd !== "save") this.scene.resumeGame();

                gameData.popupOpen = false;
            }
        );
    }

    toggleBtns(onOff)
    {
        this.btn1.setEnabled(onOff);
        this.btn2.setEnabled(onOff);
        this.exitBtn.setEnabled(onOff);
        if(this.btn3) this.btn3.setEnabled(onOff);
    }

    cleanUp()
    {
        this.toggleBtns(false);

        this.bg.destroy();
        this.exitBtn.destroy();
        this.btn1.destroy();
        this.btn2.destroy();
        this.name1.destroy();
        this.name2.destroy();
        this.shader.destroy();

        if(this.btn3) {
            this.btn3.destroy();
            this.name3.destroy();
        }
    }
}